"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var lang_service_1 = __importDefault(require("../../services/lang.service"));
var classnames_1 = __importDefault(require("classnames"));
;
var EpisodeLanguages = (function (_super) {
    __extends(EpisodeLanguages, _super);
    function EpisodeLanguages() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EpisodeLanguages.prototype.render = function () {
        var _a = this.props, comic = _a.comic, onLanguageClick = _a.onLanguageClick;
        var selectedLang = lang_service_1.default.getComicLang();
        return (react_1.default.createElement("div", { className: "episode-languages" },
            react_1.default.createElement("div", { className: "episode-languages__content" },
                react_1.default.createElement("h1", { className: "episode-languages__title" }, lang_service_1.default.getLabel('availableLangs')),
                react_1.default.createElement("ul", { className: "episode-languages__list" }, comic.supportedLangs.map(function (lang, inx) { return (react_1.default.createElement("li", { key: inx, className: (0, classnames_1.default)('episode-languages__list-item', {
                        'is-selected': !!(selectedLang === lang),
                    }), onClick: function () {
                        onLanguageClick(lang);
                    } },
                    selectedLang === lang ? react_1.default.createElement("span", { className: "icon icon-check" }) : '',
                    react_1.default.createElement("span", { className: "episode-languages__list-item-text" }, lang_service_1.default.getLabel(lang)))); })))));
    };
    return EpisodeLanguages;
}(react_1.Component));
exports.default = EpisodeLanguages;
